import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from 'i18next-http-backend';
import {englishTexts} from "./shared/utils/translations/English";
import {spanishTexts} from "./shared/utils/translations/Spanish";

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
  lng: "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
  resources: {
    en: {
      translation: englishTexts
    },
    es: {
      translation: spanishTexts
    },
  },
});

export default i18n;